import ImageViewer from './components/ImageViewer';
export default ImageViewer;
//# sourceMappingURL=index.js.map
